<template>
  <div class="video-player">
    <div ref="playerWrap" id="playerWrap" />
    <div ref="interactWrap" class="interact-wrap">
      <div v-if="curEvent" :style="interactWrapStyle">
        <!-- 互动 -->
        <component :is="curInteract" :event="curEvent" @end="posEnd" @realEnd="interactPlay" />
      </div>
    </div>
  </div>
</template>
<script>
import BfeWebVideo from '@aixuexi/bfe-web-video-ali'
// 样式
import '@aixuexi/bfe-web-video-ali/dist/style.css'

import getEvent from '@/components/VideoPlayer/interact/getEvent'
import { onMounted, onBeforeUnmount, ref, shallowRef, nextTick, computed } from '@vue/composition-api'
import videoService from '@/service/video/index'
import { getUserId } from '@/utils/tools'

export default {
  components: {},
  setup(props, { root, refs, emit }) {
    // 当前互动组件
    // 注意，使用 shallowRef（只处理基础数据类型的响应式，不进行对象类型的响应式）
    // 否则会报 performance warning using ref https://stackoverflow.com/questions/65716637/vue3-performance-warning-using-ref
    const curInteract = shallowRef(null)
    // 互动事件
    const curEvent = ref(null)
    const useEvent = getEvent()
    // 播放器实例
    const playVideo = ref(null)

    // 记录已触发互动事件
    const triggeredEvents = ref(new Set())
    /**
     * 互动结束，将当前互动销毁
     */
    function destroyInteract() {
      if (!curEvent.value) {
        return
      }
      console.log('本互动结束', curEvent.value.type)
      emit('realInteractEnd', curEvent, playVideo)
      curInteract.value = null
      curEvent.value = null
    }
    function play() {
      playVideo.value.voPlayVideo()
    }
    function pause() {
      playVideo.value.voPauseVideo()
    }
    /**
     * 互动结束，继续播放视频，不管暂停不暂停的都调用
     */
    function interactPlay() {
      destroyInteract()
      playVideo.value.voPlayVideo()
    }
    // 互动遮罩的背景色
    const interactWrapStyle = computed(() => {
      if (!curEvent.value) {
        return null
      }
      const { type, params } = curEvent.value
      const { name } = useEvent[type].component
      if (name === 'CountDown' || (name === 'NormalQue' && params.source === 3)) {
        return null
      }
      return {
        backgroundColor: `rgba(13, 15, 26, 0.8)`
      }
    })
    /**
     * 互动题显示的回调
     */
    async function interactCallback(event) {
      const { type, params, position, data } = event
      const key = `${data.id}-${position}`
      // 记录已经出触发的position
      if (triggeredEvents.value.has(key)) {
        console.warn('当前互动题已经触发过了', key)
        return
      }
      triggeredEvents.value.add(key)
      const { topicContent } = params
      const cur = useEvent[type]
      if (!cur) {
        // 当前互动不存在，关闭遮罩
        // 没有对应的事件， webfunny 警告打点
        throw new Error('没有找到对应的事件')
      }
      // 暂停播放
      // 语音齐答  互动不暂停
      const noPause = [110]
      let isPause = false
      // 一呼百应，
      try {
        if ((type === 121 && topicContent) || (type !== 121 && noPause.indexOf(type) === -1)) {
          pause()
          isPause = true
        }
        // 抛出视频开始的 emit
        emit('interactStart', isPause)
        curInteract.value = null
        curEvent.value = null
        // 将组件重置，如果两个相邻的互动为相同的组件，需要重置
        await nextTick()
        curInteract.value = cur.component
        curEvent.value = event
      } catch (e) {
        // 加载互动题失败，继续播
        if (isPause) {
          interactPlay()
        }
        throw new Error(e)
      }
    }

    const viewerId = `FOX#T_MAIN#${getUserId()}`
    console.log('player viewerId', viewerId)

    // 视频配置
    const playConf = {
      isDebugger: true,
      isShowDotAdded: true,
      playMode: 'interact',
      async playsafe(vid) {
        return await videoService.getAliToken({ vid })
      },
      getWatermark
    }
    /**
     * 获取视频信息
     */
    // function getVideoInfo() {
    //   const { aiLessonId, lessonId, classTypeId, companionUserGroupId } = props
    //   return new Promise((resolve, reject) => {
    //     videoService.viewVideo({
    //       aiLessonId,
    //       classTypeId,
    //       companionUserGroupId,
    //       // companionUserId: getUserId(),
    //       lessonId
    //     })
    //       .then(({ scriptJson, videoUrl }) => {
    //         resolve({
    //           eventList: scriptJson,
    //           vid: videoUrl
    //         })
    //       })
    //       .catch(reject)
    //   })
    // }
    /**
     * 获取水印信息
     */
    async function getWatermark() {
      const { teacherName, teacherPhone } = await videoService.insinfo()
      return `${teacherName} ${teacherPhone.substr(teacherPhone.length - 4)}`
    }
    /**
     * 生产系统配置的倒计时结束
     */
    function posEnd() {
      console.log('学生端互动结束', curEvent.value.type)
      emit('interactEnd', curEvent, playVideo)
    }

    function stop() {
      destroyInteract()
      pause()
    }

    function initPlayer() {
      /**
       * 实例化播放器
       */
      playVideo.value = new BfeWebVideo({
        videoWrapId: 'playerWrap',
        playConf,
        // 回调事件
        on: {
          tagChange: (tag, oldTag) => {
            console.log('当前播放视频片段', tag, oldTag)
            emit('tagChange', tag, oldTag)
          },
          end: () => {
            console.log('播放结束')
          },
          onseek: () => {
            // 清空已触发的互动事件
            triggeredEvents.value.clear()
          },
          interactCallback
        }
      })
    }
    onBeforeUnmount(() => {
      // 销毁
      playVideo.value?.voDestroy()
    })
    return {
      interactWrapStyle,
      curInteract,
      curEvent,
      posEnd,
      interactPlay,
      playVideo,
      pause,
      stop,
      play,
      initPlayer
    }
  }
}
</script>
<style scoped>
#playerWrap {
  width: 100%;
  height: 100%;
}
.video-player {
  height: 100%;
}
.interact-wrap {
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  z-index: 12;
  top: 0;
  left: 0;
  > div {
    height: 100%;
    width: 100%;
    pointer-events: auto;
  }
}
</style>
